import {FilterEnum} from 'Agent/Accounts/ducks/account';

export enum LineOfBusiness {
  Agent = 1,
  EnrollmentTracking = 2,
}

export const LinesOfBusinessCustomerSupport: FilterEnum[] = [
  {
    name: 'Agent',
    value: 'agent',
  },
  {
    name: 'EnrollTrack',
    value: 'enrolltrack',
  }
];

export type LinesOfBusinessCustomerSupportValue = 'agent' | 'enrolltrack' ;